import { Text } from '@actualtysoft/ui-kit';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

const Footer = (): JSX.Element => {
  return (
    <Box py={2} px={4}>
      <Grid container spacing={3}>
        <Grid size={{ md: 12 }}>
          <Text color="secondary" align="center">
            © {new Date().getFullYear()} Actual Group. Informations
            confidentielles à vocation interne uniquement.{' '}
            <Box pl={1} component="span">
              Développé avec
              <Box component="span" display="inline" mx={1}>
                ❤
              </Box>
              par la Digital Factory
            </Box>
          </Text>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
